/**
 * 美編生圖 API schema。
 *
 * 流程:
 *   1) client 從訪談附件「✨ 美編」按鈕開 dialog,選方向 + 補充說明
 *   2) client 在 local 把模板組成 prompt(沿用 features/design-prompt/templates.ts)
 *   3) client POST /design-image/generate { sourceAttachmentUuid, prompt }
 *   4) server 讀來源附件 bytes,呼叫 OpenAI /v1/images/edits,回 b64
 *   5) client 顯示 preview,確認後用既有 uploadAttachment 流程存為新附件
 *
 * 生圖通常 10~30 秒,client/server 都要拉長 timeout。
 */
import { z } from 'zod';

export const GenerateDesignImageInputSchema = z.object({
  /** 來源附件 UUID(必須是圖片 MIME)。 */
  sourceAttachmentUuid: z.string().uuid(),
  /** 完整 prompt 文字(client 端用模板組好再送)。 */
  prompt: z.string().trim().min(1).max(10_000),
});
export type GenerateDesignImageInput = z.infer<typeof GenerateDesignImageInputSchema>;

export const GenerateDesignImageResultSchema = z.object({
  /** base64 PNG(不含 data: 前綴),前端要存為附件時自行包成 Blob。 */
  b64Image: z.string(),
  /** OpenAI 實際使用的 model(例:gpt-image-1)。 */
  model: z.string(),
  /** 推薦的副檔名(目前固定 'png',gpt-image-1 回的就是 PNG)。 */
  fileExt: z.string(),
  /** OpenAI 端 latency 毫秒。 */
  latencyMs: z.number().int().nonnegative(),
});
export type GenerateDesignImageResult = z.infer<typeof GenerateDesignImageResultSchema>;
